/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Assessment from '@linc-technologies/linced-common/models/assessments/assessment';

// Proto: assessments.Batch.
export default class Batch extends Model {
  declare [Type]: 'assessments/batch';

  @attr('number')
  declare createTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare schoolId: string;

  @attr('string', { defaultValue: '' })
  declare assessorId: string;

  @belongsTo('assessments/assessment', { async: true, inverse: null })
  declare assessmentId: AsyncBelongsTo<Assessment>;

  @alias('assessmentId')
  declare assessment: AsyncBelongsTo<Assessment>;

  @attr('string', { defaultValue: '' })
  declare sourceFilename: string;

  @attr('number', { defaultValue: 0 })
  declare gradeCount: number;
}
